<template>
    <div class="home">
        <b-container>
            <b-row class="mt-5">
                <b-col lg="4" class="pt-3">
                    <img class="logo" src="@/assets/thepaymentoption-logo-white.svg"/>
                    <copyright class="dark mt-5 d-none d-lg-block"/>
                    <div class="mt-5 d-block d-lg-none"></div>
                </b-col>
                <b-col>
                    <div class="box mt-0 mb-5">
                        <div v-if="!error">
                            <h3><i class="far fa-lock-alt mr-3"></i>Accessing Your Accounts...</h3>

                            <p>Please wait...</p>
                        </div>
                        <div v-else>
                            <h3><i class="far fa-lock-alt mr-3"></i>Access Your Accounts</h3>
                            <p class="font-weight-bold"><i class="far fa-ban mr-2 text-danger"></i>We're sorry but we could not complete your login request.</p>
                            <p>It's likely that your request has either expired or has already been used. Please try again or <a href="mailto:help@thepaymentoption.com">contact us</a> or your merchant for help.</p>
                            <p class="mt-5">
                                <b-button variant="primary" :to="{name: 'home'}"><i class="far fa-sync-alt mr-2"></i>Try Again</b-button>
                            </p>
                        </div>
                    </div>

                </b-col>
            </b-row>

            <copyright class="dark mt-5 d-block d-lg-none text-center"/>

        </b-container>
    </div>
</template>

<script>
    import Copyright from "../components/Copyright";
    import {apiUrl} from '@/constants/config';
    import axios from 'axios';

    export default {
        name: 'Home',
        components: {Copyright},
        props: ['secret'],
        data: function () {
            return {
                error: null
            }
        },
        methods: {

        },
        mounted: function() {
            console.log('Validating session')
            axios.get(apiUrl + 'api/user/login/' + this.secret).then(response => {
                if (response.data.session) {
                    this.$router.push({name: 'accounts', params: {code: response.data.session}});
                }

                if (response.data.newOnboard) {
                    // Plan still in the sign-agreement flow
                    window.location.href = '/#/sign-agreement/' + response.data.newOnboard;
                }
            }, err => {
                if (err.response.status === 400) {
                    this.error = true;
                }
            });
        }
    }
</script>

<style lang="scss">

    @import '~@/assets/scss/_variables.scss';

    .home {
        display: flex;
        min-height: 100vh;

        background-color: #3c3c5f;
        padding: 1rem;
        color: #5c5c5c;

        .logo {
            width: 90%;
            max-width: 250px;
        }

        .box {
            padding: 2rem 3rem;
            background: white;
            /*margin: 5rem;*/
            border-radius: 0.5rem;
            box-shadow: 0 0 20px 10px rgba(0,0,0,0.2);

            h1, h3 {
                color: $primary;
                letter-spacing: -0.08rem;
                margin-bottom: 2rem;
            }

            .btn {
                i {
                    margin-left: 0;
                }
            }
        }
    }
</style>
